<script setup lang="ts">
import { computed } from 'vue'
import { ModuleEnum } from '../../../../../../Constants/ModuleEnum'

interface Props {
  context?: string
}

const props = defineProps<Props>()

const iconClass = computed(() => {
  const normalizedContext = props.context ? props.context.toLowerCase().split('\\').pop() : ''
  switch (normalizedContext) {
    case ModuleEnum.CONTRACT:
      return 'fa fa-file-pdf'
    case ModuleEnum.SIMULATION:
      return 'fa fa-calculator'
    case ModuleEnum.DEMAND:
      return 'fa fa-handshake'
    case ModuleEnum.INVOICE:
      return 'fa fa-file-alt'
    case ModuleEnum.WALLET:
      return 'fa fa-suitcase'
    default:
      return 'fa fa-bell'
  }
})
</script>

<template>
  <i :class="iconClass" class="notification-icon ml-2"></i>
</template>

<style lang="scss" scoped>
.notification-icon {
  font-size: 1rem;
}
</style>
